import ModalSectionHeader from "@/components/ui/ModalSectionHeader";
import { MaterialFileFormFields } from "@/components/commonFormItems/MaterialFileFormFields";
import { Col, Form, Input, Row, Select } from "antd";
import type { PurchaseContractFormValues } from "../type";
import styles from "@/asserts/styles/formSection.module.less";

const CONTRACT_SOURCE_OPTIONS = [
  { label: "采购申请", value: "PURCHASE_APPLY" },
  { label: "直接下单", value: "DIRECT_ORDER" },
  { label: "框架协议", value: "FRAME_AGREEMENT" },
];

/**
 * 申请人信息
 */
export function ApplicantFormFields() {
  return (
    <div className={styles.formSection}>
      <ModalSectionHeader title="申请人信息" />

      <div className={styles.sectionBody}>
        <Row gutter={49}>
          <Col span={8}>
            <Form.Item<PurchaseContractFormValues>
              name="applicantName"
              label="申请人"
              rules={[{ required: true, message: "请选择申请人" }]}
            >
              <Input placeholder="请选择" />
            </Form.Item>
            <Form.Item hidden name="applicantId">
              <Input />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item<PurchaseContractFormValues>
              name="departmentName"
              label="部门"
            >
              <Input placeholder="自动带出" disabled />
            </Form.Item>
            <Form.Item hidden name="departmentId">
              <Input />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item<PurchaseContractFormValues>
              name="departmentManagerName"
              label="部门主管"
            >
              <Input placeholder="自动带出" disabled />
            </Form.Item>
            <Form.Item hidden name="departmentManagerId">
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={49}>
          <Col span={8}>
            <Form.Item<PurchaseContractFormValues>
              name="factoryId"
              label="工厂"
              rules={[{ required: true, message: "请选择工厂" }]}
            >
              <Select placeholder="请选择" options={[]} />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item<PurchaseContractFormValues>
              name="contractSource"
              label="合同来源"
              rules={[{ required: true, message: "请选择合同来源" }]}
            >
              <Select placeholder="请选择" options={CONTRACT_SOURCE_OPTIONS} />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item<PurchaseContractFormValues>
              name="approvedPurchaseApplyNo"
              label="已批准采购申请表编号"
            >
              <Input placeholder="请输入或选择" />
            </Form.Item>
            <Form.Item hidden name="approvedPurchaseApplyId">
              <Input />
            </Form.Item>
          </Col>

          <Col span={24}>
            <MaterialFileFormFields<PurchaseContractFormValues>
              fieldName="attachments"
              label="附件上传"
              required={false}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
}
